import { NotificationPriorityEnum } from "@ryde/shared";
import {
  deepPurpleMui,
  rydeColors,
  rydeColorsDashboardPage,
  rydeColorsGraphsScheme,
} from "@ryde/theme";

import { IStatusIndicatorControl } from "../status-indicator-model";

export const StatusIndicatorNotificationMap: Record<
  NotificationPriorityEnum,
  IStatusIndicatorControl
> = {
  [NotificationPriorityEnum.Alert]: {
    $color: rydeColors.white,
    $bgColor: rydeColorsDashboardPage.alertText,
    $borderColor: rydeColorsGraphsScheme.Red.Red29,
  },
  [NotificationPriorityEnum.Notice]: {
    $bgColor: deepPurpleMui._50,
    $color: rydeColors.previewNumberColor,
    $borderColor: rydeColors.previewNumberColor,
  },
  [NotificationPriorityEnum.Reminder]: {
    $bgColor: deepPurpleMui._50,
    $color: rydeColors.previewNumberColor,
    $borderColor: rydeColors.previewNumberColor,
  },
};
